module.exports = {
  // 标题栏
  defaultSystemName: '企业综合信息管理平台',
  systemName: '企业综合信息管理平台',
  logoUrlDark: '@/../static/img/logoUrlDark.png',
  logoUrlLight: '@/../static/img/logoUrlLight.png',
  copyright: `2020-${new Date().getFullYear()} 江苏优车享信息科技有限公司 © 版权所有`,
  ICP: '',
  // **********  后台请求路径  ********** //
  // 本地环境: http://localhost:8100/if/
  // 测试环境: http://semp.i56/if/  <=> host 192.168.1.56
  // 生产环境：https://semp.youchexiang.com/if/
  apiBaseUrl: 'https://semp.youchexiang.com/if/',
  defaultWaterMarker: '优车享'
  // 自定义菜单页面跳转
  // ,menuPageSkip: {
  //  flag: true,
  //  icon: 'appstore',
  //  name: 'DMA漏损管理',
  //  pathParams: {
  //    clientId: 'NFS'
  //  },
  //  path: 'http://xxx.com'
  // }
}



// WEBPACK FOOTER //
// ./src/settings.js